import { IFileModel, TimesheetLogsModel } from './timesheet.model';

export interface TimesheetInitialState {
  logs: Array<TimesheetLogsModel>;
  files: IFileModel;
}

export const timesheetState: TimesheetInitialState = {
  logs: [],
  files: {
    fileName: '',
    fileUrl: '',
  },
};
